import { ArticleApi } from '@/api/article';
import StoreBuilder from '../store-builder';
import { FicheArticle } from '@/model/fiche-article';

const builder = new StoreBuilder('article');
builder.addStatePart('listeArticle', null, (codeRegion: string) => ArticleApi.getFicheArticles(codeRegion)
  .then((items) => {
    // items.forEach(f => { f.prix = 40; f.stock.valeur = 40; f.stock.stockDisponible = true; });
    return items;
  }), 'NONE', 300 /* 5m */);

builder.setLoaders({
  paramsCommandeArticle: { loadFunction: (idArticle: number) => ArticleApi.getParamsCommandeArticle(idArticle), cacheTime: 1800 }
});

builder.addStatePart('articleConsulte', { articleEnCours: FicheArticle }, null, 'SESSION');

export default builder.build();
